import { getBrowserTimeZone } from "@/utils/dateUtils";
import {
  createContext,
  createElement,
  useContext,
  useMemo,
  type ReactNode,
} from "react";

const UserTimeZoneContext = createContext<string | null>(null);

export function UserTimeZoneProvider({ children }: { children: ReactNode }) {
  const timeZone = useMemo(() => getBrowserTimeZone() ?? "UTC", []);

  return createElement(UserTimeZoneContext.Provider, { value: timeZone }, children);
}

/** The browser/device timezone where the site is being used. */
export function useUserTimeZone(): string {
  const timeZone = useContext(UserTimeZoneContext);
  if (!timeZone) {
    throw new Error("useUserTimeZone must be used within UserTimeZoneProvider");
  }
  return timeZone;
}
